import { getCalendarMilestones } from '../../../services';
import { getFirstDayOfMonth, getLastDayOfMonth } from '@gp/utils/common';

import type { IRecord, IMilestoneSimpleDTO } from '@gp/types/global';
import type { IDPSReportCalendarValue } from '@gp/types/dpsReport/v3';

const convert2MilestonesMapping = (milestones?: IMilestoneSimpleDTO[] | null): IRecord<IMilestoneSimpleDTO[]> => {
  if (!Array.isArray(milestones) || !milestones.length) return {};
  const mapping: IRecord<IMilestoneSimpleDTO[]> = {};

  for (const milestone of milestones) {
    const {
      // @ts-ignore
      project_id: projectId,
      milestone_id: milestoneId,
      milestone: milestoneName,
      date_confirm: dateConfirm,
      date,
      is_gr: isGR,
      is_launch: isLaunch,
    } = milestone || {};

    if (!mapping[projectId]) {
      mapping[projectId] = [];
    }

    mapping[projectId].push({
      milestone_id: milestoneId,
      milestone: milestoneName,
      date_confirm: dateConfirm,
      date,
      is_gr: isGR,
      is_launch: isLaunch,
    });
  }

  return mapping;
};

export const generateMilestonesMapping = async (
  calendarsData?: IDPSReportCalendarValue | null,
): Promise<IRecord<IMilestoneSimpleDTO[]>> => {
  const { start_date: calendarsStartDate, end_date: calendarsEndDate, list: calendars } = calendarsData || {};
  const projectIds = calendars?.map((calendar) => calendar?.project_id);
  const milestones = await getCalendarMilestones({
    project_id: projectIds || [],
    start_date: getFirstDayOfMonth(calendarsStartDate),
    end_date: getLastDayOfMonth(calendarsEndDate),
  });
  return convert2MilestonesMapping(milestones);
};
